export default __webpack_public_path__ + "static/media/queue-outline.3e43bef2.svg";